module.exports = __webpack_public_path__ + "img/16.bde8342a.png";